export enum FrequencyCap {
    Unlock = "ulk",
    InView = "ivw",
    Impression = "imp",
    NthArticle = "nth",
    InitialArticles = "ini"
}
